import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth, homeRouteFor } from '../hooks/useAuth';
import toast from 'react-hot-toast';
import { Eye, EyeOff } from 'lucide-react';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(form.email, form.password);
      navigate(homeRouteFor(data.user?.rol));
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0d0d0d', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ width: 60, height: 60, background: '#7B0D0D', borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 28 }}>⬡</div>
          <h1 style={{ color: 'white', fontSize: 26, fontWeight: 700, letterSpacing: 2 }}>ODIN</h1>
          <p style={{ color: '#666', fontSize: 14, marginTop: 4 }}>Sistema de Gestión CRM</p>
        </div>

        <div style={{ background: '#1a1a1a', borderRadius: 16, padding: 32, border: '1px solid #2d2d2d' }}>
          <h2 style={{ color: 'white', fontSize: 20, fontWeight: 600, marginBottom: 24 }}>Iniciar sesión</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label" style={{ color: '#aaa' }}>Correo electrónico</label>
              <input className="form-input" type="email" required
                style={{ background: '#2d2d2d', border: '1px solid #3d3d3d', color: 'white' }}
                value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
                placeholder="tucorreo@email.com" />
            </div>
            <div className="form-group">
              <label className="form-label" style={{ color: '#aaa' }}>Contraseña</label>
              <div style={{ position: 'relative' }}>
                <input className="form-input" type={showPass ? 'text' : 'password'} required
                  style={{ background: '#2d2d2d', border: '1px solid #3d3d3d', color: 'white', paddingRight: 44 }}
                  value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
                  placeholder="••••••••" />
                <button type="button" onClick={() => setShowPass(!showPass)}
                  style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#666' }}>
                  {showPass ? <EyeOff size={18}/> : <Eye size={18}/>}
                </button>
              </div>
            </div>
            <div style={{ textAlign: 'right', marginBottom: 20 }}>
              <Link to="/forgot-password" style={{ color: '#7B0D0D', fontSize: 13, textDecoration: 'none' }}>¿Olvidaste tu contraseña?</Link>
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '12px', fontSize: 15 }} disabled={loading}>
              {loading ? <><span className="spinner"/> Ingresando...</> : 'Ingresar'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
